@if (loading()) {
  <div class="flex items-center gap-3 p-12 text-sm text-muted-foreground">
    <hlm-spinner size="20" />
    Loading contracts…
  </div>
} @else {
  @if (session.customer(); as c) {
    <div class="mb-5 rounded-2xl border border-border bg-card p-5 shadow-sm">
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div class="flex min-w-0 flex-col gap-1">
          <p class="font-mono-feat text-sm font-semibold uppercase tracking-[0.10em] text-muted-foreground">
            Contracts · Customer {{ c.id }}
          </p>
          <h1 class="font-display text-2xl font-semibold leading-tight text-foreground">
            {{ c.contractFullName }}
            <span class="font-normal text-muted-foreground">({{ c.companyName }})</span>
          </h1>
          <p class="text-sm text-muted-foreground">
            Invoicing day
            <strong class="font-mono-feat text-foreground">{{ c.invoiceDay }}</strong>
          </p>
        </div>
        <div class="flex flex-none items-center gap-2 pt-1">
          <button hlmBtn variant="outline" (click)="syncExtensions()" [disabled]="syncing()">
            @if (syncing()) {
              <hlm-spinner size="14" /> Syncing…
            } @else {
              <hlm-icon name="lucideRefreshCw" size="0.9rem" />
              Sync extensions
            }
          </button>
          <!-- Old-CMT parity (EB-3881): a cancelled customer (endDate set) shows Reactivate
               instead of Cancel; reactivation is handled in Manage Services (SMT). -->
          @if (c.endDate) {
            <button hlmBtn (click)="reactivateCustomer()"
                    class="bg-success text-white shadow-sm hover:bg-success/90">
              <hlm-icon name="lucideRotateCcw" size="0.9rem" />
              Reactivate Customer
            </button>
          } @else {
            <button hlmBtn variant="destructive" (click)="cancelCustomer()">
              <hlm-icon name="lucideCircleX" size="0.9rem" />
              Cancel Customer
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (contracts().length === 0) {
    <div class="rounded-2xl border border-dashed border-border bg-card/50 p-12 text-center text-sm text-muted-foreground">
      No contracts found for this customer.
    </div>
  } @else {
    @if (contracts().length > 3) {
      <div class="mb-5 flex items-center gap-3 rounded-2xl border border-border bg-card p-3 shadow-sm">
        <div class="relative flex-1">
          <hlm-icon
            name="lucideSearch"
            size="1.05rem"
            class="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <input
            hlmInput
            class="pl-10 pr-10 text-sm"
            placeholder="Search contract #, account, name, or phone number…"
            [ngModel]="searchText()"
            (ngModelChange)="onSearchChange($event)"
          />
          @if (searching()) {
            <span class="absolute right-3 top-1/2 -translate-y-1/2">
              <hlm-spinner size="14" />
            </span>
          } @else if (searchText()) {
            <button
              type="button"
              (click)="clearSearch()"
              class="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
              aria-label="Clear search"
            >
              <hlm-icon name="lucideX" size="0.85rem" />
            </button>
          }
        </div>
        @if (searchText()) {
          <span class="font-mono-feat text-sm text-muted-foreground">
            {{ filteredContracts().length }} / {{ contracts().length }}
          </span>
        }
      </div>
    }

    <div class="flex flex-col gap-3">
      @for (contract of filteredContracts(); track contract.id) {
        <cmt-contract-panel
          [contract]="contract"
          [highlightContractId]="highlightContractId()"
          (contractsChanged)="loadContracts()"
        />
      }
      @if (searchText() && filteredContracts().length === 0) {
        <div class="rounded-2xl border border-dashed border-border bg-card/50 p-8 text-center text-sm text-muted-foreground">
          No contracts match "{{ searchText() }}"
        </div>
      }
    </div>
  }
}
